import React, { Component } from "react";
import Topnav from "../common/Topnav";
import Footer from "../common/Footer";
import { Container, Row, Col, Breadcrumb } from "react-bootstrap";
import bannerImage from "../../Images/about/codeofconductbanner.webp";


const CocFaculty = () => {
  return (
    <>
      <title>Faculty Code of Conduct | ISBM University.</title>
      <meta
        name="description"
        content="Explore ISBM University’s Faculty Code of Conduct, promoting ethics, professionalism, and academic integrity for a thriving learning environment."
      />
      <Topnav />
      <section
        className="section-hero-banner ptb-50"
        style={{
          backgroundImage: `linear-gradient(rgba(28,36,71,0.8), rgba(28,36,71,0.8)), url(${bannerImage})`,
        }}
      >
        <div className="banner-hero-overlay">
          <div className="container-xxl">
            <div className="section-hero-content">
              <h1>CODE OF PROFESSIONAL ETHICS FOR FACULTY MEMBERS</h1>
              <ol className="breadcrumb mt-3 text-center mb-0">
                <li className="breadcrumb-item">
                  <a href="/" style={{ color: "#fff", textDecoration: "none" }}>
                    Home
                  </a>
                </li>
                <li
                  className="breadcrumb-item active text-white"
                  aria-current="page"
                >
                  Code of Conduct (Faculty)
                </li>
                <hr className="section-divider" />
              </ol>
            </div>
          </div>
        </div>
      </section>

      <section className="ptb-50">
        <div className="container-xxl">
          <Row className="justify-content-center">
            <Col lg={10}>
              <div className="coc-card shadow p-4 p-lg-5">
                {/* Section (a) */}
                <div className="conduct-section mb-5">
                  <h3 className="fw-bold text-blue mb-4">
                    <i className="ti ti-user-circle me-2"></i>
                    THE TEACHERS AND THEIR PROFESSIONAL RESPONSIBILITIES
                  </h3>
                  <p className="section-intro">
                    Any person who takes teaching as a profession assumes the obligation to conduct
                    himself/herself in accordance with the ideals of the profession. The teacher is
                    constantly under the scrutiny of his/her students and the society at large.
                  </p>

                  <h4 className="subsection-title">A teacher shall:</h4>
                  <ol className="conduct-items">
                    <li>Adhere to a responsible pattern of conduct and demeanor expected of him/her by his/her peers and the community.</li>
                    <li>Prefer constructive, reflective, collaborative, integrative and enquiry-based approach and pedagogical tools for teaching-learning assignment.</li>
                    <li>Communicate effectively while facilitating students and other stakeholders and the preferably language is English.</li>
                    <li>Wear smart professional attire at the workplace preferably in decent formals.</li>
                    <li>Manage his/her private affairs in a manner consistent with the dignity of the profession.</li>
                    <li>Seek to make professional growth continuous through study, research, writing, and participating in seminar, workshops, symposia with decent conduct.</li>
                    <li>Express free and frank opinion by active participation at professional meetings, seminars, conferences, by contribution towards the contribution of knowledge.</li>
                    <li>Maintain active membership in professional organizations, subscribing to academic/subject periodicals, and strive to improve education and profession.</li>
                    <li>Perform his/her duties in the form of teaching, tutorial, practical and seminar work with dedication.</li>
                    <li>Co-operate and assist in carrying out functions relating to the educational responsibilities of the University such as: assisting and appraising applications for admission, advising and counselling students as well as assisting in the conduct of University examinations, including supervision, invigilation, and evaluation.</li>
                    <li>Participate in extension, co-curricular and extracurricular activities including community service.</li>
                    <li>Try to complete assigned task in timely manner less adhering to the deadlines assigned.</li>
                  </ol>
                </div>

                {/* Section (b) */}
                <div className="conduct-section mb-5">
                  <h3 className="fw-bold text-blue mb-4">
                    <i className="ti ti-school me-2"></i>
                    TEACHERS AND THE STUDENTS
                  </h3>

                  <h4 className="subsection-title">A teacher shall:</h4>
                  <ol className="conduct-items">
                    <li>Respect the right and dignity of the student while expressing his/her opinion.</li>
                    <li>Deal impartially with students regardless of their religion, caste, sex, political, economic, social, and physical status.</li>
                    <li>Mark his/her attendance preferably within 10 minutes of the commencement of lecture and on the day of the class.</li>
                    <li>Recognize the difference in aptitude and capabilities among students and strive to meet their academic needs.</li>
                    <li>Encourage students to improve their attainments, develop their personalities and at the same time contributing to community welfare.</li>
                    <li>Inculcate among students scientific, progressive, and rational outlook and respect for physical labour and ideals of democracy, patriotism, and peace.</li>
                    <li>Be affectionate to the students and not behave in a vindictive manner towards any student for any reason.</li>
                    <li>Pay attention for the attainment of the student in the assessment of merit.</li>
                    <li>Make himself/herself available to the students even beyond their class hours to help and guide them without any remuneration or reward.</li>
                    <li>Refrain from inciting students against other students, colleagues, or administration.</li>
                  </ol>
                </div>

                {/* Section (c) */}
                <div className="conduct-section mb-5">
                  <h3 className="fw-bold text-blue mb-4">
                    <i className="ti ti-users me-2"></i>
                    TEACHERS AND COLLEAGUES
                  </h3>

                  <h4 className="subsection-title">The teachers shall always:</h4>
                  <ol className="conduct-items">
                    <li>Treat other members of the profession in an equitable and decent manner.</li>
                    <li>Speak respect of other teachers and render assistance for professional betterment.</li>
                    <li>Refrain from lodging unsubstantiated allegations against colleagues to higher authorities.</li>
                    <li>Refrain from exploiting considerations of caste, creed, religion, race, or gender in their professional endeavor.</li>
                    <li>Thorough social and humane, democratic and rational, towards other teachers.</li>
                    <li>Strive at any cost to remove and wash out the local tensions and controversies and disputes.</li>
                    <li>Believe in the unity of colleagues.</li>
                  </ol>
                </div>

                {/* Section (d) */}
                <div className="conduct-section mb-5">
                  <h3 className="fw-bold text-blue mb-4">
                    <i className="ti ti-building me-2"></i>
                    TEACHERS AND AUTHORITIES
                  </h3>

                  <h4 className="subsection-title">A teacher shall:</h4>
                  <ol className="conduct-items">
                    <li>Discharge their professional responsibilities according to the existing rules and adhere to procedures and methods consistent with their profession in initiating steps through their university for change of any such rule detrimental to the professional interest.</li>
                    <li>Not undertake any other employment and commitment including private tuition and coaching classes.</li>
                    <li>Co-operate in the formulation of policies of the institution by accepting various offices and discharging responsibilities that such offices may demand.</li>
                    <li>Co-operate with the authorities for the betterment of the institutions keeping in view the interest and in conformity with the dignity of the profession.</li>
                    <li>Should adhere to the conditions of the contract.</li>
                    <li>Give and expect due notice before a change of position is made.</li>
                    <li>Refrain from availing themselves of leave except on unavoidable grounds and as far as practicable with prior intimation, keeping in view their particular responsibility for completion of the academic schedule.</li>
                  </ol>
                </div>

                {/* Section (e) */}
                <div className="conduct-section mb-5">
                  <h3 className="fw-bold text-blue mb-4">
                    <i className="ti ti-user-plus me-2"></i>
                    TEACHERS AND NON-TEACHING EMPLOYEES
                  </h3>
                  <p className="section-content">
                    The teachers should treat the non-teaching employees as colleagues with equality and fraternity.
                  </p>
                </div>

                {/* Section (f) */}
                <div className="conduct-section mb-5">
                  <h3 className="fw-bold text-blue mb-4">
                    <i className="ti ti-user me-2"></i>
                    TEACHERS AND GUARDIANS
                  </h3>
                  <p className="section-content">
                    The teachers shall try to maintain contact with the guardians of their students, send a report of their performance to the guardians whenever necessary, and meet the guardians in meetings convened for mutual exchange of ideas and the benefit of the university.
                  </p>
                </div>

                {/* Section (g) */}
                <div className="conduct-section">
                  <h3 className="fw-bold text-blue mb-4">
                    <i className="ti ti-world me-2"></i>
                    TEACHERS AND SOCIETY
                  </h3>

                  <h4 className="subsection-title">The teachers shall</h4>
                  <ol className="conduct-items">
                    <li>Recognize that education is a public service and strive to keep the public informed of the educational programmes which are being provided.</li>
                    <li>Work to improve education in the community and strengthen the community's moral and intellectual life.</li>
                    <li>Be aware of social and economic problems and take part in such activities as would be conducive to the progress of society and hence the country as a whole.</li>
                    <li>Perform the duties of citizenship, participate in community activities, and shoulder responsibilities of public office.</li>
                    <li>Refrain from taking part in or subscribing to or assisting in any way, activities that tend to promote a feeling of hatred or enmity among communities, relations, or linguistic groups but actively work for national integration.</li>
                  </ol>
                </div>

                {/* Additional Points */}
                <div className="additional-section mt-5 pt-4 border-top">
                  <ol className="additional-items">
                    <li>Maintain the highest standards of discipline and dignified manner of behaviour inside as well as outside the university campus. They shall abide by the rules and regulations of the university and should act in a way that highlights the discipline and esteem of the institute.</li>
                    <li>Work in the time schedule from Monday to Friday is followed. Classes are scheduled from 9.15 a.m. to 3.00 p.m. All the students are expected to be present in the class well - within time and late coming will attract a loss of attendance for the corresponding hour.</li>
                    <li>Encourage student seminars/workshops/webinars/project presentations etc., all the students of the concerned class must be present for the entire session.</li>
                    <li>Permit students in case of sickness or other valid grounds requires a gate pass with an application duly forwarded by the HOD and Dean. Application for medical leave shall be accompanied by valid medical fitness certificate of the treating Doctor while resuming classes after illness.</li>
                    <li>Advise to refrain from activities such as scribbling or noting on student desks, doors, or other furniture which could deface the university and destroy the academic ambiance.</li>
                    <li>Advise students to handle the chemicals, apparatus, equipment, fixtures and appliances carefully of the laboratories/workshops of the university. Careless handling/misuse of the above could result in personal injuries or damage to property. Follow safety precautions near moving machines and electrical installations. In the event of property damage, the responsible students will have to bear the cost of replacement/repair with a fine.</li>
                    <li>Students are not allowed to arrange any unauthorized celebrations and decorations of any magnitude in the campus.</li>
                    <li>Students are not allowed to distribute or display (both physically and electronically) material such as notices or banners etc. in the campus without the permission of the competent authority.</li>
                    <li>Initiate action in case of non-compliance the code of conduct means for students or any observed matter/behaviour that deviates from the vision and mission of the code of conduct, all the faculty members are empowered to initiate the disciplinary procedure by filling in a standard form which in turn may lead to the constitution of an inquiry committee for further proceedings.</li>
                  </ol>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default CocFaculty;
